import { createFileRoute } from '@tanstack/react-router'
import { trpc } from '@/main'
import { noop } from '@tanstack/react-query'

// Pathless layout that OWNS both search-keyed list queries, so `q`/`o`/`type` re-key THIS match and not the section
// root above it — the root paints the section skeleton at `pendingMs: 0`, and a re-key there would swap the rail for
// the skeleton on every debounced keystroke, unmounting the search box (see jobs._list.tsx). The panels read this
// match with `getRouteApi('/_app/offers/_list')` / `useMatch({ from })`, which match on every URL under the section.
export const Route = createFileRoute('/_app/offers/_list')({
  loaderDeps: ({ search }) => ({ q: search.q, o: search.o, type: search.type }),
  // Both list keys, search included. `q`/`o`/`type` live in the URL, so the loader and the panels read the ONE
  // object each built here — no unsearched-vs-searched pair, and nothing for a panel to mint.
  context: ({ deps }) => ({
    companyOffersInfiniteQueryOptions: trpc.companies.getOffersInfinite.infiniteQueryOptions(
      { q: deps.q, isPosition: false },
      { getNextPageParam: (lastPage) => lastPage.nextCursor },
    ),
    applicantOffersInfiniteQueryOptions: trpc.applicants.getOffersInfinite.infiniteQueryOptions(
      // `o` falls back to 'added': the root schema leaves it undefined, and substituting here is what keeps this
      // key identical to the one already cached.
      { q: deps.q, o: deps.o ?? 'added', type: deps.type },
      { getNextPageParam: (lastPage) => lastPage.nextCursor },
    ),
  }),
  loader: ({ context }) => {
    context.queryClient.infiniteQuery(context.companyOffersInfiniteQueryOptions).catch(noop)
    context.queryClient.infiniteQuery(context.applicantOffersInfiniteQueryOptions).catch(noop)
  },
})
